<template>
  <div class="section-login-page">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-12 col-xl-8">
          <div class="login-page">
            <div class="login-page__form">
              <div class="login-page__logo"><img src="../assets/images/logo.svg" alt=""></div>
              <form @submit.prevent="performLogin()" id="login-form" autocomplete="off">
                <div class="inputs-wr login-login">
                  <label for="login-form-login">Логин</label>
                  <input v-model="login" id="login-form-login" type="text" aria-required="true">
                </div>
                <div class="input-wr login-password">
                  <!--когда показан пароль добавить для show-password класс '.show'-->
                  <div class="show-password" v-on:click="showPasswordFunction()" v-bind:class="{show : (showPassword)}"></div>
                  <label for="login-form-pass">Пароль</label>

                  <input v-if="showPassword" v-model="password" id="login-form-pass" type="text"  aria-required="true">
                  <input v-else="" v-model="password" id="login-form-pass" type="password"  aria-required="true">
                </div>
                <div class="input-wr sidebar_checks">
                  <input v-model="remember" type="checkbox" id="loginform-rememberme">
                  <label class="control-label" for="loginform-rememberme"><a>Запомнить меня</a></label>
                </div>
                <div class="button-wr">
                  <button type="submit">войти</button>
                </div>
              </form>
            </div>
            <div class="login-page__icons">
              <img src="../assets/images/login/icons.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data () {
    return {
      login: '',
      password: '',
      remember: true,
      showPassword: false
    }
  },
  computed: {
    isLoading () {
      return this.$store.getters[ 'security/isLoading' ]
    },
    hasError () {
      return this.$store.getters[ 'security/hasError' ]
    },
    error () {
      return this.$store.getters[ 'security/error' ]
    }
  },
  created () {
    this.$store.dispatch('station/unsetCurrent')

    let redirect = this.$route.query.redirect

    if (this.$store.getters[ 'security/isAuthenticated' ]) {
      if (typeof redirect !== 'undefined') {
        this.$router.push({ path: redirect })
      } else {
        this.$router.push({ path: '/ststions' })
      }
    }
  },
  methods: {
    async performLogin () {
      let payload = {
        login: this.login,
        password: this.password
      }; let redirect = this.$route.query.redirect

      await this.$store.dispatch('security/login', payload)
      if (!this.$store.getters[ 'security/hasError' ]) {
        if (typeof redirect !== 'undefined') {
          this.$router.push({ path: redirect })
        } else {
          this.$router.push({ path: '/stations' })
        }
      }
    },
    showPasswordFunction () {
      this.showPassword = !this.showPassword
    }
  }
}
</script>
